import React from 'react';
import { SelectValueViewer } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useCompanyListOptions from 'pages/Waterfall/components/CompanyList/useCompanyListOptions';

const CompanyListValueViewer = (props: CustomSelectProps) => {

  const { options } = useCompanyListOptions()
  return <SelectValueViewer {...props} options={options}/>;
}

export default CompanyListValueViewer;